<template>
  <div style="overflow: hidden">
    <!-- 浮動 LINE 聯絡按鈕 -->
    <v-btn fab dark color="#06C755" class="floating-contact-btn line-floating-btn" @click="showContactDialog = true">
      <v-img src="../assets/line4.png" width="20" class="line-icon"></v-img>
    </v-btn>

    <v-btn fab dark color="#797C80ee" class="scrollup-btn" v-if="showScrollup" @click="scrollup">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

    <!-- LINE 聯絡對話框 -->
    <v-dialog v-model="showContactDialog" max-width="400">
      <v-card class="contact-dialog">
        <v-card-title class="text-h6 font-weight-bold primary--text pb-2">
          {{ $t("footer-comment-title") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showContactDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6 text-center">
          <p class="text-body-1 mb-4">{{ $t("qrcode") }}</p>
          <div class="qrcode-dialog-wrapper mx-auto">
            <v-img src="../assets/qrcode.jpg" contain max-width="200" height="auto"
              class="qrcode-image mx-auto"></v-img>
            <p class="text-caption mt-3 grey--text text--darken-1">
              <v-icon small class="me-1">mdi-cellphone</v-icon>
              {{ $t("scan") }}
            </p>
          </div>
          <v-divider class="my-4"></v-divider>
          <v-btn block large color="#06C755" dark @click="toLine" class="rounded-lg">
            <v-icon left>mdi-open-in-new</v-icon>
            {{ $t("footer-comment") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Navigation Components -->
    <TopBar :language="language" :languageList="languageList" :activeButton="activeButton" :currentPage="'home'"
      @change-language="changeLanguage" @scroll-to-target="handleScrollToTarget" ref="navbar" />
    <MobileNavigation :languageList="languageList" :currentPage="'home'" @change-language="changeLanguage"
      @scroll-to-target="scrollToTarget" />
    <!-- banner -->
    <div class="banner-bg py-16" id="header">
      <v-container fill-height>
        <v-row class="wow fadeInDown align-center mx-auto pt-16">
          <v-col class="col-12 col-sm-9 col-xl-6" style="z-index: 3">
            <h2 class="text-h5 text-sm-h3 font-weight-black tech-text" style="color: #fac13dd6">
              <span class="text-highlight">LIFE</span> IS <span class="text-highlight">TOUGH</span>
            </h2>
            <h1 class="text-h4 text-sm-h2 font-weight-black my-3 tech-text-primary" style="color: #fac04d">
              WE CAN DO <span class="glitch-effect" data-text="MOOOORE">MOOOORE</span>
            </h1>
            <div class="tech-line"></div>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <div class="pic-aitt">
          <!-- <v-img src="../assets/aitt.svg"></v-img> -->
        </div>
      </v-container>
    </div>
    <!-- 服務資訊 -->
    <div class="solution-bg py-16">
      <section id="solution">
        <v-container class="py-8">
          <h2 class="wow fadeInLeft text-h4 font-weight-black mb-16 text-start" data-wow-delay="0.1s">
            {{ $t("solution") }}
            <span class="text-h6 title-decorate" style="color: #fac03d">■</span>
          </h2>
          <br />
          <h2 class="wow fadeInDown text-h4 text-sm-h3 font-weight-bold font-italic text-center" style="color: #797c80">
            {{ $t("solution_title") }}
          </h2>
          <h3 class="wow fadeInDown text-h5 text-sm-h4 my-4 my-sm-8 font-weight-bold font-italic text-center"
            style="color: #797c80">
            {{ $t("solution_subtitle") }}
          </h3>
          <br />
          <div class="pb-16">
            <v-row class="d-flex align-center px-2">
              <v-col class="col-12 col-sm-6 col-md-3 order-1 order-md-first">
                <v-row>
                  <v-col class="wow fadeInLeft col-12 py-4 py-md-10 ps-4 ps-md-16">
                    <v-card height="100%" min-width="100%" elevation="0" style="background-color: transparent">
                      <p class="text-h5 font-weight-black mb-4">
                        {{ $t("solution_content_1") }}
                      </p>
                      <div class="d-flex align-center mb-1">
                        <p>{{ $t("solution_content_1_point1") }}</p>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col class="wow fadeInLeft col-12 py-4 py-md-10" data-wow-delay="0.1s">
                    <v-card height="100%" min-width="100%" elevation="0" style="background-color: transparent">
                      <p class="text-h5 font-weight-black mb-4">
                        {{ $t("solution_content_2") }}
                      </p>
                      <div class="d-flex align-center mb-1">
                        <p>{{ $t("solution_content_2_point1") }}</p>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="wow fadeInDown col-12 col-sm-7 col-md-6 order-sm-first mx-auto">
                <lottie :options="defaultOptions" :height="350" :width="350" />
              </v-col>
              <v-col class="wow fadeInRight col-12 col-sm-6 col-md-3">
                <v-row>
                  <v-col class="wow fadeInRight col-12 py-4 py-md-10">
                    <v-card height="100%" min-width="100%" elevation="0" style="background-color: transparent">
                      <p class="text-h5 font-weight-black mb-4">
                        {{ $t("solution_content_4") }}
                      </p>
                      <div class="d-flex align-center mb-1">
                        <p class="mb-0">
                          {{ $t("solution_content_4_point1") }}
                        </p>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col class="wow fadeInRight col-12 py-4 py-md-10 ps-4 ps-md-16" data-wow-delay="0.1s">
                    <v-card height="100%" min-width="100%" elevation="0" style="background-color: transparent">
                      <p class="text-h5 font-weight-black mb-4">
                        {{ $t("solution_content_5") }}
                      </p>
                      <div class="d-flex align-center mb-1">
                        <p class="mb-0">
                          {{ $t("solution_content_5_point1") }}
                        </p>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <!-- BI核心應用領域 -->
          <div class="bi-core-section py-16">
            <h2 class="wow fadeInDown text-h4 text-sm-h3 my-8 my-sm-16 font-weight-bold font-italic text-center"
              style="color: #797c80">
              {{ $t("bi_core_title") }}
            </h2>
            <v-row class="pt-16">
              <v-col cols="12" md="4" class="mb-6">
                <v-card class="bi-tag-item pa-6 rounded-lg" elevation="0" height="100%">
                  <div class="d-flex align-center mb-4">
                    <span class="hashtag text-h4" style="color: #fac03d">#</span>
                    <h3 class="text-h5 font-weight-black ml-2">
                      {{ $t("bi_reservation_title") }}
                    </h3>
                  </div>
                  <h4 class="text-h6 font-weight-bold mb-4" style="color: #797c80">
                    {{ $t("bi_reservation_subtitle") }}
                  </h4>
                  <p class="text-body-1">
                    {{ $t("bi_reservation_description") }}
                  </p>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="mb-6">
                <v-card class="bi-tag-item pa-6 rounded-lg" elevation="0" height="100%">
                  <div class="d-flex align-center mb-4">
                    <span class="hashtag text-h4" style="color: #fac03d">#</span>
                    <h3 class="text-h5 font-weight-black ml-2">
                      {{ $t("bi_sales_title") }}
                    </h3>
                  </div>
                  <h4 class="text-h6 font-weight-bold mb-4" style="color: #797c80">
                    {{ $t("bi_sales_subtitle") }}
                  </h4>
                  <p class="text-body-1">
                    {{ $t("bi_sales_description") }}
                  </p>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="mb-6">
                <v-card class="bi-tag-item pa-6 rounded-lg" elevation="0" height="100%">
                  <div class="d-flex align-center mb-4">
                    <span class="hashtag text-h4" style="color: #fac03d">#</span>
                    <h3 class="text-h5 font-weight-black ml-2">
                      {{ $t("bi_consumption_title") }}
                    </h3>
                  </div>
                  <h4 class="text-h6 font-weight-bold mb-4" style="color: #797c80">
                    {{ $t("bi_consumption_subtitle") }}
                  </h4>
                  <p class="text-body-1">
                    {{ $t("bi_consumption_description") }}
                  </p>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <h2 class="wow fadeInDown text-h4 text-sm-h3 my-8 my-sm-16 font-weight-bold font-italic text-center"
            style="color: #797c80">
            {{ $t("solution_subtitle2") }}
          </h2>
          <div class="py-16">
            <v-row class="px-3">
              <v-col class="wow fadeInDown col-12 col-md-6 col-lg-6">
                <v-row>
                  <v-col class="col-12 col-sm-7 mx-auto">
                    <lottie :options="defaultOptions3" :height="350" :width="350" />
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col class="col-12 col-md-6 col-lg-6">
                <v-row>
                  <v-col class="col-12 col-sm-6">
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.1s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step1") }}
                        </v-card-title>
                        <p>{{ $t("step1_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">1</P>
                      </v-card>
                    </v-col>
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.15s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step2") }}
                        </v-card-title>
                        <p>{{ $t("step2_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">2</P>
                      </v-card>
                    </v-col>
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.2s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step3") }}
                        </v-card-title>
                        <p>{{ $t("step3_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">3</P>
                      </v-card>
                    </v-col>
                  </v-col>
                  <v-col class="col-12 col-sm-6">
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.25s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step4") }}
                        </v-card-title>
                        <p>{{ $t("step4_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">4</P>
                      </v-card>
                    </v-col>
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.3s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step5") }}
                        </v-card-title>
                        <p>{{ $t("step5_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">5</P>
                      </v-card>
                    </v-col>
                    <v-col class="wow fadeInDown col-12" data-wow-delay="0.3s">
                      <v-card class="num-card rounded-lg pa-4 ps-7 mx-auto" height="100%" max-width="480px"
                        elevation="0">
                        <v-card-title class="ps-0 text-h5 font-weight-black">
                          {{ $t("step6") }}
                        </v-card-title>
                        <p>{{ $t("step6_content") }}</p>
                        <P class="num-dec text-h2 font-weight-black">6</P>
                      </v-card>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </section>
    </div>
    <!-- 關於我們 -->
    <div class="about-bg">
      <section id="about">
        <v-container class="py-16 about-title">
          <h2 class="wow fadeInLeft text-h4 font-weight-bold text-start white--text mb-16" data-wow-delay="0.1s">
            {{ $t("about") }}
            <span class="text-h6 title-decorate-about" style="color: #fffff">■</span>
          </h2>
          <v-card class="pa-2 pb-5 mx-auto" max-width="900px" elevation="0" style="background-color: transparent">
            <v-card-text class="white--text text-body-1">
              <strong class="text-h4 font-weight-bold">
                {{ $t("company") }}</strong>
              {{ $t("about_content") }}
            </v-card-text>
          </v-card>

          <v-card class="about-contain" elevation="12">
            <v-row>
              <v-col class="col-12 col-sm-4">
                <v-card class="rounded-lg pa-md-5 px-5 pt-5 pb-0" height="100%" elevation="0"
                  style="background-color: transparent">
                  <v-card-title class="px-0">
                    <v-img src="../assets/icon4.png" max-width="50px" contain></v-img>
                    <p class="text-h5 font-weight-black mb-0 ms-2">
                      {{ $t("about1") }}
                    </p>
                  </v-card-title>
                  <p>{{ $t("about1_content") }}</p>
                </v-card>
              </v-col>
              <v-divider vertical class="my-10"></v-divider>
              <v-col class="col-12 col-sm-4">
                <v-card class="rounded-lg pa-md-5 px-5 py-0" height="100%" elevation="0"
                  style="background-color: transparent">
                  <v-card-title class="px-0">
                    <v-img src="../assets/icon2.png" max-width="50px" contain></v-img>
                    <p class="text-h5 font-weight-black mb-0 ms-2">
                      {{ $t("about2") }}
                    </p>
                  </v-card-title>
                  <p>{{ $t("about2_content") }}</p>
                </v-card>
              </v-col>
              <v-divider vertical class="my-10"></v-divider>
              <v-col class="col-12 col-sm-4">
                <v-card class="rounded-lg pa-md-5 px-5 py-0" height="100%" elevation="0"
                  style="background-color: transparent">
                  <v-card-title class="px-0">
                    <v-img src="../assets/icon3.png" max-width="50px" contain></v-img>
                    <p class="text-h5 font-weight-black mb-0 ms-2">
                      {{ $t("about3") }}
                    </p>
                  </v-card-title>
                  <p>{{ $t("about3_content") }}</p>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </section>
    </div>

    <!-- 案例展示 -->
    <div class="cases-preview-bg">
      <section id="cases">
        <v-container class="py-8">
          <h2 class="wow fadeInLeft text-h4 font-weight-black mb-16 text-start">
            {{ $t("cases") }}
            <span class="text-h6 title-decorate" style="color: #fac03d">■</span>
          </h2>

          <v-row>
            <v-col v-for="(caseItem, index) in featuredCases" :key="index" cols="12" md="6" class="mb-6">
              <v-card class="case-preview-card rounded-lg pa-4 ps-7 mx-auto" elevation="0" height="100%">
                <v-card-title class="text-h6 font-weight-bold">
                  {{ caseItem.title }}
                </v-card-title>
                <v-card-subtitle class="text-body-2 mt-2">
                  {{ caseItem.client }}
                </v-card-subtitle>
                <v-card-text>
                  <p class="text-body-2 case-summary">
                    {{ caseItem.summary }}
                  </p>
                  <div class="d-flex flex-wrap mt-3">
                    <v-chip v-for="(tag, tIdx) in caseItem.tags" :key="tIdx" outlined color="grey" class="me-2">
                      {{ tag }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <div class="text-center mt-8">
            <v-btn x-large class="rounded-lg" color="warning" @click="goToCases">
              {{ $t("view_more_cases") }}
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-container>
      </section>
    </div>

    <!-- 聯絡我們 -->
    <div class="contact-bg">
      <section id="contact">
        <v-container class="py-16">
          <h2 class="wow fadeInLeft text-h4 font-weight-black mb-16 text-start">
            {{ $t("contact") }}
            <span class="text-h6 title-decorate" style="color: #fac03d">■</span>
          </h2>

          <p class="text-body-1">{{ $t("contact_title") }}</p>
          <p class="font-weight-bold mb-4 text-h6 text-md-h5 grey--text text--darken-1">
            {{ $t("contact_subtitle") }}
          </p>
          <v-row class="mb-8">
            <!-- 台北辦公室 -->
            <v-col cols="12" lg="6" class="wow fadeInLeft" data-wow-delay="0.1s">
              <v-card class="contact-card pa-6" elevation="0">
                <div class="contact-header mb-4">
                  <h3 class="text-h6 font-weight-bold">{{ $t("taipei_office") }}</h3>
                </div>
                <div class="contact-details mb-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-office-building</v-icon>
                    <span class="text-body-2">{{ $t("taipei_office_name") }}</span>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-map-marker</v-icon>
                    <span class="text-body-2">{{ $t("taipei_office_address") }}</span>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-phone-classic</v-icon>
                    <a :href="'tel:' + $t('phone_number')" class="text-body-2 contact-link">{{ $t("phone_number") }}</a>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-email-multiple</v-icon>
                    <a :href="'mailto:' + $t('email_address')" class="text-body-2 contact-link">{{ $t("email_address") }}</a>
                  </div>
                </div>
                <div class="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.5351757697817!2d121.54351607515953!3d25.083739077784173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442ac052cdee7b7%3A0xa36331af9cc35e96!2zMTA0OTHlj7DljJfluILkuK3lsbHljYDlpKfnm7TooZc3MOiZn0jmo58t57ac5ZCI5aSn5qiT!5e0!3m2!1szh-TW!2stw!4v1703661933405!5m2!1szh-TW!2stw"
                    width="100%" height="280" style="border: 0; border-radius: 1rem" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                  </iframe>
                </div>
              </v-card>
            </v-col>

            <!-- 總部 -->
            <v-col cols="12" lg="6" class="wow fadeInRight" data-wow-delay="0.2s">
              <v-card class="contact-card pa-6" elevation="0">
                <div class="contact-header mb-4">
                  <h3 class="text-h6 font-weight-bold">{{ $t("headquarters") }}</h3>
                </div>
                <div class="contact-details mb-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-office-building</v-icon>
                    <span class="text-body-2">{{ $t("headquarters_name") }}</span>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-map-marker</v-icon>
                    <span class="text-body-2">{{ $t("headquarters_address") }}</span>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-phone-classic</v-icon>
                    <a :href="'tel:' +'03-4941110'" class="text-body-2 contact-link">03-4941110</a>
                  </div>
                  <div class="d-flex align-center mb-2">
                    <v-icon small class="me-2">mdi-email-multiple</v-icon>
                    <a :href="'mailto:' + $t('email_address')" class="text-body-2 contact-link">{{ $t("email_address") }}</a>
                  </div>
                </div>
                <div class="contact-map">
                  <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57882.08591899513!2d121.16783860737524!3d24.944658935571148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346823aecc62f83f%3A0x483e0347d84adc0f!2z5ZCN5qC85LiW57SA5buj5aC06L6m5YWs5aSn5qiT!5e0!3m2!1szh-TW!2stw!4v1756963139897!5m2!1szh-TW!2stw"
                  width="100%"
                  height="280"
                  style="border: 0; border-radius: 1rem"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                >
                </iframe>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>

    <v-footer dark padless>
      <v-card class="flex" flat tile>
        <v-card-text class="py-2 white--text text-center" style="background-color: #797c80">
          {{ $t("copyRight") }}{{ new Date().getFullYear() }} —
          {{ $t("company") }}
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>
<script>
import Lottie from "@/components/Lottie.vue";
import TopBar from "@/components/TopBar.vue";
import MobileNavigation from "@/components/MobileNavigation.vue";
import * as animationData from "../assets/device.json";
import * as animationData2 from "../assets/ui.json";
import * as animationData3 from "../assets/ai.json";
import { getCaseStudies } from "@/data/caseStudies/index.js";

export default {
  props: {
    lang: {
      type: String,
      default: "zh-TW",
    },
  },
  data() {
    return {
      defaultOptions: { animationData: animationData },
      defaultOptions2: { animationData: animationData2 },
      defaultOptions3: { animationData: animationData3 },
      activeButton: "",
      showScrollup: false,
      showContactDialog: false,
      language: {
        value: this.lang,
        title: this.lang === "en" ? "English" : "繁體中文",
      },
      languageList: [
        {
          value: "zh-TW",
          title: "繁體中文",
        },
        {
          value: "en-US",
          title: "English",
        },
        {
          value: "ja-JP",
          title: "日本語",
        },
      ],
      items: [
        {
          title: "M4ORE medical",
          image: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
        },
        {
          title: "M4ORE BI",
          image: "https://cdn.vuetifyjs.com/images/cards/plane.jpg",
        },
        {
          title: "M4ORE sport",
          image: require("@/assets/sport.jpg"),
        },
      ],
    };
  },
  components: {
    lottie: Lottie,
    TopBar,
    MobileNavigation,
  },
  methods: {
    changeLanguage(lang) {
      let selectedLanguage;

      if (lang !== undefined) {
        if (typeof lang === "number") {
          selectedLanguage = this.languageList[lang] || this.languageList[0];
        } else {
          selectedLanguage =
            this.languageList.find((l) => l.value === lang) ||
            this.languageList[0];
        }
      } else {
        const currentIndex = this.languageList.findIndex(
          (l) => l.value === this.language.value
        );
        const nextIndex = (currentIndex + 1) % this.languageList.length;
        selectedLanguage = this.languageList[nextIndex];
      }

      this.language = selectedLanguage;

      switch (this.language.value) {
        case "zh-TW":
          this.$i18n.locale = "tw";
          break;
        case "en-US":
          this.$i18n.locale = "en";
          break;
        case "ja-JP":
          this.$i18n.locale = "jp";
          break;
      }

      this.$router
        .push({ query: { ...this.$route.query, lang: this.language.value } })
        .catch((err) => { });
    },
    handleScrollToTarget(target) {
      this.activeButton = target;
      this.scrollToTarget(target);
    },
    scrollToTarget(target) {
      const el = document.getElementById(target);
      if (el) {
        // 確保 navbar ref 存在
        if (this.$refs.navbar && this.$refs.navbar.$el) {
          const navbarHeight = this.$refs.navbar.$el.clientHeight;
          const yOffset = navbarHeight;
          const y = el.getBoundingClientRect().top + window.pageYOffset - yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          // 如果 navbar ref 不存在，直接滾動
          const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showScrollup = scrollTop > 100;
    },
    scrollup() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.activeButton = "";
    },
    toLine() {
      window.location.assign("https://lin.ee/if90tjF");
    },
    goToWebsite(item) {
      if (item.title === "M4ORE sport") {
        window.location.assign("https://sport.m4ore.com/");
      }
    },
    goToCases() {
      window.location.assign('https://m2.m4ore.com/#/cases')
    },
  },

  computed: {
    featuredCases() {
      const locale = this.$i18n.locale;
      const localeMap = {
        'tw': 'zh-TW',
        'en': 'en',
        'jp': 'ja'
      };
      const { caseStudies } = getCaseStudies(localeMap[locale] || 'zh-TW');
      return caseStudies.filter(c => c.featured).slice(0, 4);
    }
  },

  watch: {
    '$route.query.scrollTo': {
      handler(scrollTo) {
        if (scrollTo) {
          // 使用多層 nextTick 確保所有組件都已渲染
          this.$nextTick(() => {
            this.$nextTick(() => {
              setTimeout(() => {
                this.scrollToTarget(scrollTo);
                // 清除 scrollTo 參數
                const query = { ...this.$route.query };
                delete query.scrollTo;
                this.$router.replace({ query }).catch(() => {});
              }, 400);
            });
          });
        }
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      if (this.$wow && typeof this.$wow === 'function') {
        try {
          new this.$wow().init();
        } catch (error) {
          console.warn('WOW.js initialization failed:', error);
        }
      }
    });
    this.changeLanguage(this.lang);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style>
.cusor-pointer {
  cursor: pointer;
}

.scrollup-btn {
  position: fixed;
  bottom: 6rem;
  right: 2rem;
  z-index: 5;
}

/* 浮動聯絡按鈕 */
.floating-contact-btn {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 5;
}

.line-floating-btn .v-image {
  filter: brightness(0) invert(1);
}

.line-icon {
  margin: 8px;
}

.line-floating-btn:hover {
  transform: scale(1.1);
}

/* 聯絡對話框 */
.contact-dialog {
  border-radius: 16px !important;
}

.qrcode-dialog-wrapper {
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 20px;
  display: inline-block;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 響應式調整 */
@media screen and (max-width: 600px) {
  .floating-contact-btn {
    bottom: 1rem;
    right: 1rem;
  }

  .scrollup-btn {
    bottom: 5rem;
    right: 1rem;
  }
}


/* banner */
.banner-bg {
  position: relative;
  /* 優先使用 dvh,降級到 vh */
  height: 65vh;
  height: 65dvh;
  min-height: 550px; /* 保底高度 */
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/bg.jpg");
  background-size: cover;
  background-position: center;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.pic-dec {
  position: absolute;
  top: 0;
  left: -10%;
  width: 90%;
  filter: hue-rotate(200deg) saturate(1);
  opacity: 0.4;
}

.pic-aitt {
  position: absolute;
  opacity: 0.4;
  right: -70%;
  filter: hue-rotate(200deg) saturate(1);
  width: 130%;
}

@media screen and (max-width: 376px) {
  .pic-aitt {
    opacity: 0.2;
    left: -20%;
    top: 9%;
    width: 240%;
  }
}

@media screen and (min-width: 376px) and (max-width: 600px) {
  .pic-aitt {
    opacity: 0.2;
    left: -37%;
    top: 6%;
    width: 315%;
  }
}

@media screen and (min-width: 600px) and (max-width: 767px) {
  .pic-aitt {
    opacity: 0.2;
    left: 10%;
    top: 6%;
    width: 177%;
  }
}

@media screen and (min-width: 768px) and (max-width: 997px) {
  .pic-aitt {
    opacity: 0.2;
    left: -6%;
    top: 0%;
    width: 220%;
  }
}

@media screen and (min-width: 997px) and (max-width: 1263px) {
  .pic-aitt {
    /* opacity: 0.2;
    left: -30%;
    top: -4%;
    width: 304%; */
    opacity: 0.2;
    left: 35%;
    top: -30%;
    width: 125%;
  }
}

@media screen and (min-width: 1263px) and (max-width: 1365px) {
  .pic-aitt {
    opacity: 0.2;
    left: -2%;
    top: -4%;
    width: 244%;
  }
}

@media screen and (min-width: 1366px) and (max-width: 1920px) {
  .pic-aitt {
    opacity: 0.2;
    left: 0%;
    top: 0%;
    width: 230%;
  }
}

@media screen and (max-width: 767px) {
  .cases-preview-bg {
    padding: 620px 0px 80px 0px !important;
  }
}

@media screen and (min-width: 998px) and (max-width: 1366px) {
  .pic-dec {
    left: -24%;
    top: 15%;
    width: 150%;
    opacity: 0.8;
  }

  .cases-preview-bg {
    padding: 200px 0px 80px 0px !important;
  }
}

/* 高 DPI 小螢幕特殊處理 */
@media screen and (max-width: 1680px) and (min-resolution: 1.5dppx) {
  .banner-bg {
    min-height: max(65vh, 100dvh);
  }
}

/* 大螢幕保持美觀 */
@media screen and (min-width: 1366px) and (max-width: 1920px) and (max-resolution: 1.49dppx) {
  .banner-bg {
    height: 85vh;
    height: 85dvh;
  }
}

@media screen and (min-width: 1921px) and (max-resolution: 1.49dppx) {
  .banner-bg {
    height: 85vh;
    height: 85dvh;
  }
}

/* 標題裝飾 */
.title-decorate,
.title-decorate-about {
  position: relative;
}

.title-decorate::after {
  content: "";
  width: 100px;
  height: 2px;
  background: #fac03d;
  position: absolute;
  left: 22px;
  bottom: 8px;
}

.title-decorate-about::after {
  content: "";
  width: 100px;
  height: 2px;
  background: #f0f0f0;
  position: absolute;
  left: 22px;
  bottom: 8px;
}

.about-bg {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/bg.jpg");
  background-size: cover;
  background-color: black;
  padding-bottom: 160px;
}

.about-title {
  position: relative;
}

.about-contain {
  position: absolute;
  bottom: -90%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 3;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .about-contain {
    bottom: -195% !important;
    width: 90% !important;
  }
}

@media screen and (min-width: 600px) and (max-width: 767px) {
  .about-contain {
    bottom: -105% !important;
    width: 90% !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 997px) {
  .about-contain {
    bottom: -115% !important;
    width: 90% !important;
  }
}

@media screen and (min-width: 997px) and (max-width: 1263px) {
  .about-contain {
    bottom: -125% !important;
    width: 90% !important;
  }
}

@media screen and (min-width: 1266px) and (max-width: 1365px) {
  .about-contain {
    bottom: -100% !important;
    width: 90% !important;
  }
}

.solution-bg {
  background: linear-gradient(#ffffff, #f4eddf);
}

.contact-bg {
  background: linear-gradient(#ffffff, #f4eddf);
}

.num-card {
  position: relative;
}

.num-dec {
  position: absolute;
  top: 30%;
  left: -7%;
  font-style: italic;
  color: #ebbf4a;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.5s ease;
  opacity: 0;
}

.hover-overlay.active {
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 1;
}

.hover-text {
  color: white;
  font-size: 24px;
  transition: opacity 0.5s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.line-container {
  display: flex;
  align-items: center;
}

.line-btn {
  transition: all 0.3s;
}

.line-btn.on-hover {
  background-color: rgba(254, 226, 85, 0.389);
}

.qrcode-wrapper {
  border: 1px dashed #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  display: inline-block;
}

.qrcode-image {
  transition: transform 0.3s;
}

.qrcode-wrapper:hover .qrcode-image {
  transform: scale(1.05);
}

.scan-hint {
  color: #666;
}

/* BI 核心應用領域 */
.bi-core-section {
  max-width: 1200px;
  margin: 0 auto;
}

.bi-tag-item {
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.bi-tag-item:hover {
  border-left-color: #fac03d;
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.hashtag {
  font-weight: bold;
  line-height: 1;
}

/* 案例展示 */
.cases-preview-bg {
  padding: 250px 0px 80px 0px;
  background: linear-gradient(#f4eddf, #ffffff);
}

.case-preview-card {
  transition: all 0.3s ease;
  border-top: 3px solid transparent;
}

.case-preview-card:hover {
  border-top-color: #fac03d;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.case-summary {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

/* 聯絡我們卡片 */
.contact-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.contact-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.contact-header {
  border-bottom: 2px solid #fac03d;
  padding-bottom: 0.5rem;
}

.contact-details .v-icon {
  color: #797c80;
}

.contact-map iframe {
  transition: all 0.3s ease;
}

.contact-link {
  color: #797c80;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #fac03d;
  text-decoration: underline;
}

/* 文字效果優化 */
.tech-text {
  position: relative;
  letter-spacing: 1px;
  animation: text-fade-in 1.5s forwards;
  text-shadow: 0 0 10px rgba(250, 193, 61, 0.3);
}

.text-highlight {
  position: relative;
  color: #fac04d;
  text-shadow: 0 0 15px rgba(250, 193, 61, 0.5);
}

.tech-text-primary {
  position: relative;
  letter-spacing: 2px;
  text-shadow:
    0 0 20px rgba(250, 193, 61, 0.5),
    0 0 40px rgba(250, 193, 61, 0.3);
  animation: text-pulse 4s infinite alternate;
}

.glitch-effect {
  position: relative;
  display: inline-block;
  color: #fac04d;
}

.glitch-effect:before,
.glitch-effect:after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.glitch-effect:before {
  left: 2px;
  text-shadow: -1px 0 rgba(255, 0, 193, 0.5);
  clip: rect(44px, 450px, 56px, 0);
  animation: glitch-anim-1 5s infinite linear alternate-reverse;
}

.glitch-effect:after {
  left: -2px;
  text-shadow: -1px 0 rgba(0, 255, 249, 0.5);
  clip: rect(44px, 450px, 56px, 0);
  animation: glitch-anim-2 5s infinite linear alternate-reverse;
}

.tech-line {
  height: 3px;
  width: 0%;
  background: linear-gradient(to right,
      transparent,
      rgba(250, 193, 61, 0.3),
      rgba(250, 193, 61, 0.8),
      rgba(250, 193, 61, 0.3),
      transparent);
  margin-top: 20px;
  animation: line-extend 2s forwards;
  box-shadow: 0 0 10px rgba(250, 193, 61, 0.4);
}

/* 動畫定義 */
@keyframes text-fade-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes text-pulse {

  0%,
  100% {
    text-shadow:
      0 0 15px rgba(250, 193, 61, 0.4),
      0 0 30px rgba(250, 193, 61, 0.2);
  }

  50% {
    text-shadow:
      0 0 25px rgba(250, 193, 61, 0.6),
      0 0 50px rgba(250, 193, 61, 0.3);
  }
}

@keyframes glitch-anim-1 {
  0% {
    clip: rect(30px, 9999px, 10px, 0);
  }

  20% {
    clip: rect(61px, 9999px, 98px, 0);
  }

  40% {
    clip: rect(7px, 9999px, 94px, 0);
  }

  60% {
    clip: rect(86px, 9999px, 73px, 0);
  }

  80% {
    clip: rect(67px, 9999px, 13px, 0);
  }

  100% {
    clip: rect(18px, 9999px, 71px, 0);
  }
}

@keyframes glitch-anim-2 {
  0% {
    clip: rect(34px, 9999px, 29px, 0);
  }

  20% {
    clip: rect(82px, 9999px, 2px, 0);
  }

  40% {
    clip: rect(23px, 9999px, 37px, 0);
  }

  60% {
    clip: rect(67px, 9999px, 80px, 0);
  }

  80% {
    clip: rect(80px, 9999px, 0px, 0);
  }

  100% {
    clip: rect(65px, 9999px, 83px, 0);
  }
}

@keyframes line-extend {
  0% {
    width: 0%;
  }

  100% {
    width: 100%;
  }
}

/* 優化高解析度文字大小 */
@media screen and (min-width: 1680px) {
  .text-h5.text-sm-h3 {
    font-size: 3.5rem !important;
    line-height: 1.2 !important;
  }

  .text-h4.text-sm-h2 {
    font-size: 4.5rem !important;
    line-height: 1.2 !important;
  }

  .tech-line {
    height: 4px;
    margin-top: 30px;
  }
}

@media screen and (min-width: 1920px) {
  .text-h5.text-sm-h3 {
    font-size: 4rem !important;
    line-height: 1.2 !important;
  }

  .text-h4.text-sm-h2 {
    font-size: 5rem !important;
    line-height: 1.2 !important;
  }
}
</style>
